/**
 * CommentDeleteReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * CommentDeleteReq
 */
export interface CommentDeleteReq {
  /** 资源ID */
  id: string
  /** 删除原因 */
  reason: string
}

/**
 * CommentDeleteReq Schema
 */
export const CommentDeleteReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '资源ID',
      format: 'string',
      type: 'string',
      label: '资源ID',
    },
    reason: {
      description: '删除原因',
      format: 'string',
      type: 'string',
      label: '删除原因',
    },
  },
  required: ['id', 'reason'],
  type: 'object',
}
